function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { generateId, stringToHtmlFragment } from '../utils/index';
import { ID_TOAST_CONTAINER, DEFAULT_CONFIG, CLASS_DISMISSED_STATE, DATA_ATTR_CLOSE_BUTTON, EVENT_OPEN, EVENT_CLOSE, EVENT_DISMISS } from './toast.config.js';
import { toastTemplate, containerTemplate } from './toast.template.js';

Sage.toast = function () {
  function trigger(args) {
    var config = _objectSpread(_objectSpread({
      id: generateId('toast')
    }, DEFAULT_CONFIG), args);

    _injectToast(config);

    _setToastTimer(config);

    return config.id;
  }

  function dismiss(toastId) {
    var elToast = document.getElementById(toastId);
    if (!elToast) return false;
    elToast.classList.add(CLASS_DISMISSED_STATE);

    _dispatchEvent(EVENT_CLOSE);

    _unbindEvents(elToast);

    return true;
  }

  function reset() {
    var elContainer = document.getElementById(ID_TOAST_CONTAINER);
    if (!elContainer) return false;

    _dispatchEvent(EVENT_CLOSE);

    _unbindEvents(elContainer);

    elContainer.remove();
    return true;
  }

  function _injectToast(config) {
    var elContainer = document.getElementById(ID_TOAST_CONTAINER); // If a toast container is present, inject toast template into
    //   the currently existing toast container;
    // If a toast container is not present, wrap toast template with the
    //   container template and use `document.body` as the injection point
    //   for the container with included toast child.

    var scope = elContainer || document.body;
    var content = elContainer ? toastTemplate(config) : containerTemplate({
      content: toastTemplate(config)
    });
    var toastFragment = stringToHtmlFragment(content);

    _bindEvents(toastFragment);

    _dispatchEvent(EVENT_OPEN);

    scope.appendChild(toastFragment);
  }

  function _setToastTimer(config) {
    if (config.timer) setTimeout(function () {
      return dismiss(config.id);
    }, config.timer);
  }

  function _bindEvents(el) {
    el.querySelector("[".concat(DATA_ATTR_CLOSE_BUTTON, "]")).addEventListener('click', _handleCloseButtonClick);
  }

  function _unbindEvents(el) {
    el.querySelector("[".concat(DATA_ATTR_CLOSE_BUTTON, "]")).removeEventListener('click', _handleCloseButtonClick);
  }

  function _handleCloseButtonClick(evt) {
    dismiss(evt.target.parentElement.id);

    _dispatchEvent(EVENT_DISMISS);
  }

  function _dispatchEvent(evt) {
    document.dispatchEvent(new Event(evt));
  }

  return {
    trigger: trigger,
    dismiss: dismiss,
    reset: reset
  };
}();